module.exports = __webpack_public_path__ + "img/logo-kakao-vx-2@2x.def03c75.png";